import { FilterXSS } from 'xss'

const xss = new FilterXSS({
  allowList: {
    b: [],
    strong: [],
  },
  stripIgnoreTag: true,
})

export function sanitizeHtml(html: string): string {
  return xss.process(html)
}

const xssFilter = new FilterXSS({
  allowList: {},
  stripIgnoreTag: true,
})

export function removeHtmlTags(html: string): string {
  return xssFilter.process(html).trim()
}
